<template>
   <header class="header" ref="header">
    <div class="header__bg hide-mobile"></div>
    <div class="header__content wrapper">
      <div
        :class="burgerClass"
        @click="toggleMobileMenu">
        <div class="header__burger-element header__burger-element--top"/>
        <div class="header__burger-element header__burger-element--middle"/>
        <div class="header__burger-element header__burger-element--bottom"/>
      </div>
      <div class="header__logo">
        <router-link to="/">
          <img src="../../assets/images/logo.svg" alt="Logo">
        </router-link>
      </div>
      <div class="header__main">
        <div class="header__content-left">
          <transition name="hide">
            <h2 v-if="show" class="hide-mobile">Bürgerservice-Portal Augsburg</h2>
          </transition>
          <div class="header__nav">
            <router-link to="/services" class="dropdown">
              <Icon icon="burger" color="green"/>Dienstleistungen
              <div class="dropdown-content">
                <router-link to="/services"><Icon icon="arrowRight" color="green"/>Alle Leistungen</router-link>
                <router-link to="/lebensbereiche"><Icon icon="arrowRight" color="green"/>Lebensbereiche</router-link>
                <router-link to="/services"><Icon icon="arrowRight" color="green"/>Meist genutzt</router-link>
                <router-link to="/behoerden"><Icon icon="arrowRight" color="green"/>Ämter & Behörden</router-link>
              </div>
            </router-link>
            <router-link to="/termin-reservieren"><Icon icon="arrowRight" color="green"/>Termin reservieren</router-link>
            <router-link to="#"><Icon icon="arrowRight" color="green"/>Mitsprechen</router-link>
          </div>
      </div>
      <div class="header__content-right">
        <div class="header__icons">
            <div
            v-click-outside="closeSearch"
            :class="searchClasses"
          >
            <div
              class="header__search-icon"
              @click="toggleSearch"
            >
            <Icon icon="search" color="blue" class="hide-mobile"/>
            <Icon icon="search" color="white" class="hide-desktop"/>
            </div>
            <div
              class="header__search-bar"
            >
              <input
                ref="search"
                type="text"
                v-model="searchTerm"
                placeholder="Nach Dienstleistungen oder Behörden suchen..."
                class="header__search-input"
                @keyup.enter="search"
              >
            </div>
          </div>
          <Icon icon="font" class="accessibility hide-mobile"/>
          <Icon icon="contrast" class="accessibility hide-mobile"/>
        </div>
        <!-- Logout -->
        <router-link v-if="isAuthenticated" to="/buergerkonto" class="dropdown login-link hide-mobile">
            <Icon icon="arrowRight" color="green"/>
            <span class="font-bold">Mein Bürgerkonto</span>
            <div class="dropdown-content">
              <div @click="logout" class="login-link"><Icon icon="arrowRight" color="green"/>Abmelden</div>
            </div>
        </router-link>

        <!-- Login -->
        <div v-else @click="toggleLogin" class="login-link hide-mobile">
          <Icon icon="arrowRight" color="green"/>
          <span class="font-bold">Login Bürgerkonto</span>
        </div>
        <Modal v-if="showLogin" @closeModal="toggleLogin">
          <div class="login-modal">
            <div class="login">
              <Headline subline="Login" headline="Anmeldung in Ihr Bürgerkonto" />
              <p>Um auf Ihre Dokumente, Nachrichten und Antrags-Status zugreifen zu können, loggen Sie sich bitte hier 
                in Ihr Bürgerkonto ein. Sie benötigen Ihre Ausweis-Nummer und ihr persönliches Bürgerkonto-Passwort.</p>
              <form @submit.prevent="handleLogin({idNumber, password})">
                <div class="input-wrapper margin-top--40">
                  <input v-model="idNumber" type="text" name="idNumber" id="idNumber" placeholder="Ausweis-Nr."/>
                  <Icon icon="idCard" color="grey"/>
                </div>
                <div class="input-wrapper">
                  <input v-model="password" type="password" name="passwort" id="password" placeholder="Passwort"/>
                  <Icon icon="lock" color="grey"/>
                </div>
                <transition name="error">
                  <div v-if="!access" class="error margin-bottom--20">Falsche Ausweis-Nr. oder Passwort. Wiederholen Sie die Eingabe.</div>
                </transition>
                <Button type="primary" text="Anmelden" @click.native="handleLogin({idNumber, password})" />
                <div class="row margin-top--20">
                  <router-link to="/" class="login-link col-xs-12 col-sm-6"><Icon icon="arrowRight" color="green"/>Passwort vergessen?</router-link>
                  <router-link to="/datenschutz" class="login-link col-xs-12 col-sm-6"><Icon icon="arrowRight" color="green"/>Datenschutz</router-link>
                </div>
              </form>
            </div>
            <div class="regist">
              <Headline subline="Registrierung" headline="Noch kein Bürgerkonto?" />
              <p>Um auf Ihre Dokumente, Nachrichten und Antrags-Status zugreifen zu können, loggen Sie sich bitte hier 
                in Ihr Bürgerkonto ein. Sie benötigen Ihre Ausweis-Nummer und ihr persönliches Bürgerkonto-Passwort.</p>
              <div class="icons">
                <Icon icon="augsburg" color="detailed"/>
                <Icon icon="perlachturm" color="detailed"/>
              </div>
              <Button type="secondary" text="Zur Registrierung" />
            </div>
          </div>
        </Modal>

      </div>
      </div>
    </div>
    <transition name="fade">
      <div
        v-if="mobileMenu"
        class="header__burger-menu">
        <div class="header__burger-menu-content">
          <h1>Navigation</h1>
          <div class="greenline"></div>
          <div class="header__burger-menu-nav">
            <router-link
              to="/"
              @click.native="toggleMobileMenu"><Icon icon="arrowRight" color="green"/>Alle Leistungen</router-link>
            <router-link
              to="/archiv"
              @click.native="toggleMobileMenu"><Icon icon="arrowRight" color="green"/>Kebenslagen</router-link>
            <router-link
              to="/archiv"
              @click.native="toggleMobileMenu"><Icon icon="arrowRight" color="green"/>Meist genutzt</router-link>
            <router-link
              to="/archiv"
              @click.native="toggleMobileMenu"><Icon icon="arrowRight" color="green"/>Ämter & Behörden</router-link>
            <router-link
              to="/archiv"
              @click.native="toggleMobileMenu"><Icon icon="arrowRight" color="green"/>Termin reservieren</router-link>
            <router-link
              to="/archiv"
              @click.native="toggleMobileMenu"><Icon icon="arrowRight" color="green"/>Mitsprechen</router-link>
              <hr>
            <router-link
              to="/archiv"
              @click.native="toggleMobileMenu"><Icon icon="arrowRight" color="green"/>Login Bürgerkonto</router-link>
          </div>
          <div class="header__burger-menu-footer">
            <router-link
              to="datenschutz"
              @click.native="toggleMobileMenu">Datenschutz</router-link>
            <router-link
              to="impressum"
              @click.native="toggleMobileMenu">Impressum</router-link>
            <a href="mailto:sam@hs-augsburg.de">Kontakt</a>
          </div>
        </div>
      </div>
    </transition>
  </header>
</template>

<script>
import ClickOutside from "vue-click-outside";
import { mapActions, mapGetters } from "vuex";
import classnames from "classnames";
import Modal from "../Modal/Modal";
import Headline from "../Headline/Headline";
import Icon from "../Icon/Icon";
import Button from "../Button/Button";

export default {
  name: "Header",
  components: {
    Icon,
    Modal,
    Headline,
    Button
  },
  directives: {
    ClickOutside
  },
  props: {
  },
  data() {
    return {
      searchExpanded: false,
      searchTerm: "",
      mobileMenu: false,
      mobileDropdown: false,
      idNumber: null,
      password: '',
      show: true,
      showLogin: false,
      hallo: '',
    };
  },
  computed: {
    searchClasses() {
      const baseClass = "header__search";

      return classnames(baseClass, {
        [`${baseClass}--expanded`]: this.searchExpanded
      });
    },
    burgerClass() {
      return classnames("header__burger", {
        "header__burger--open": this.mobileMenu
      });
    },
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      userSession: 'auth/getUserSession',
      access: 'auth/getAccess',
    }),
  },
  methods: {
    closeSearch() {
      this.searchExpanded = false;
    },
    toggleSearch() {
      this.searchExpanded = !this.searchExpanded;

      if (this.searchExpanded) {
        setTimeout(() => {
          this.$refs.search.focus();
        }, 100);
      }
    },
    search() {
      this.closeSearch();
      this.$router.push({
        name: "Search",
        query: { search: this.searchTerm },
      });
      this.searchTerm = '';
    },
    toggleMobileMenu() {
      this.mobileMenu = !this.mobileMenu;
      this.mobileDropdown = false;

      if (this.mobileMenu) {
        document.querySelector("body").style.overflow = "hidden";
      } else {
        document.querySelector("body").style.overflow = "initial";
      }
    },
    toggleClass() {
      if (window.pageYOffset > 160) {
        this.$refs.header.classList.add('small');
        this.show = false;
      } else {
        this.$refs.header.classList.remove('small');
        this.show = true;
      }
    },
    toggleLogin() {
      this.showLogin = !this.showLogin;
    },
    handleLogin(idNumber, password) {
      this.login(idNumber, password);
      console.log(this.access);
      if(this.access) {
        this.toggleLogin();
      }
    },
    ...mapActions({
      login: 'auth/login',
      logout: 'auth/logout',
    }),
  },
  mounted() {
    var self = this
    window.onscroll = function() {
      self.toggleClass();
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./Header.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Header/Header.vue